export const CHAPTER_COLORS = [
  "#f43f7d",
  "#f5a623",
  "#4a7dff",
  "#52c41a",
  "#a259ff",
  "#4dd0e1",
];

export const getChapterColor = (index) => CHAPTER_COLORS[index % CHAPTER_COLORS.length];
